import * as React from "react";
import type { SVGProps } from "react";
const SvgRefreshCcw = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 4a1 1 0 1 0-2 0zm-1 6H0a1 1 0 0 0 1 1zm6 1a1 1 0 1 0 0-2zm15 9a1 1 0 1 0 2 0zm1-6h1a1 1 0 0 0-1-1zm-6-1a1 1 0 1 0 0 2zm2.547-3.666a1 1 0 1 0 1.886-.668zM5.64 5.64l.685.729.022-.022zm12.72 12.72-.685-.729-.022.022zM4.453 14.666a1 1 0 0 0-1.886.668zM0 4v6h2V4zm1 7h6V9H1zm23 9v-6h-2v6zm-1-7h-6v2h6zm-1.567-4.334a10 10 0 0 0-2.784-4.138L17.32 6.023a8 8 0 0 1 2.227 3.31zm-2.784-4.138a10 10 0 0 0-4.437-2.28L13.771 4.2a8 8 0 0 1 3.55 1.823zm-4.437-2.28a10 10 0 0 0-4.985.148l.556 1.921A8 8 0 0 1 13.77 4.2zm-4.985.148a10 10 0 0 0-4.294 2.537l1.414 1.414a8 8 0 0 1 3.436-2.03zM4.955 4.911l-4.64 4.36 1.37 1.458 4.64-4.36zm17.36 8.36-4.64 4.36 1.37 1.458 4.64-4.36zm-4.662 4.382a8 8 0 0 1-3.436 2.03l.556 1.92a10 10 0 0 0 4.294-2.536zm-3.436 2.03a8 8 0 0 1-3.988.117l-.441 1.951a10 10 0 0 0 4.985-.147zm-3.988.117a8 8 0 0 1-3.55-1.823l-1.328 1.495a10 10 0 0 0 4.437 2.28zm-3.55-1.823a8 8 0 0 1-2.226-3.31l-1.886.667a10 10 0 0 0 2.784 4.138z"
    />
  </svg>
);
export default SvgRefreshCcw;
